<template>
    <div>
        <paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"
            @show="showModal = true">
        </paginated-search>

    </div>
</template>
<script>
import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
import CompanyDepartment from "@/models/companyDepartment.model.vue";
//import EspressoAux from "@/components/Espresso/EspressoAux.vue";
export default {
    components: {
        PaginatedSearch,
    },
    data() {
        return {
            company: {
                id: this.$route.params.id,
            },
            schema: CompanyDepartment.getSchema(),            
        }
    },
    methods: {
        openEntity(entity) {
            this.$router.push(`/empresa/${this.company.id}/departamento/${entity.id}`);
        },
        createEntity() {
            this.$router.push(`/empresa/${this.company.id}/departamento/novo`);
        },
        searchEntities(paginationParameters) {
            paginationParameters.companyId = this.company.id;
            return CompanyDepartment.search(paginationParameters);
        },
    }
}
</script>
<style scoped></style>